<template>
  <div>
    <generic-container
      :title="process.name"
      icon="setting"
      :header_buttons="header_buttons"
    >
      <div class="ui five item pointing menu">
        <a class="item active" data-tab="tracker">
          <i class="find icon"></i>
          {{ $t("instance tracker") }}
        </a>
        <a class="item" data-tab="modifiers">
          <i class="code icon"></i>
          {{ $t("test") }}
        </a>
        <a class="item" data-tab="arguments">
          <i class="users icon"></i>
          {{ $t("enrollment") }}
        </a>
        <a class="item" data-tab="outcomes">
          <i class="heartbeat icon"></i>
          {{ $t("monitor") }}
        </a>
        <a class="item" data-tab="public">
          <i class="globe americas icon"></i>
          {{ $t("public") }}
        </a>
      </div>
      <div class="ui bottom attached tab active" data-tab="tracker">
        <instance-tracker-manager :process="lProcess" />
      </div>
      <div class="ui bottom attached tab" data-tab="modifiers">
        <test-manager :process="lProcess" />
      </div>
      <div class="ui bottom attached tab" data-tab="arguments">
        <enrollment-manager :process="lProcess" ref="enrollment" />
      </div>
      <div class="ui bottom attached tab" data-tab="outcomes">
        <monitor-manager :process="lProcess" />
      </div>
      <div class="ui bottom attached tab" data-tab="public">
        <public-manager :process="lProcess" />
      </div>
    </generic-container>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import InstanceTrackerManager from "./InstanceTrackerManager";
import MonitorManager from "./MonitorManager";
import TestManager from "./TestManager";
import EnrollmentManager from "./EnrollmentManager";
import PublicManager from "./PublicManager";

export default {
  name: "ProcessManagement",
  props: { process: Object },
  components: {
    "generic-container": GenericContainer,
    InstanceTrackerManager,
    TestManager,
    EnrollmentManager,
    MonitorManager,
    PublicManager,
  },
  filters: filters,
  data() {
    return {
      lProcess: {
        definitions: [],
        roles: [],
      },
      header_buttons: [
        {
          click: this.show_key,
          icon: "key",
          color: "blue",
          tooltip: this.$t("show key"),
        },
        {
          click: this.set_default,
          icon: "bullseye",
          color: "green",
          tooltip: this.$t("set as default"),
        },
        {
          click: this.remove,
          icon: "red trash",
          color: "red",
        },
      ],
    };
  },
  methods: {
    filter(filter) {
      console.log(filter);
      // if (filter == "") this.partitions = this.all_partitions;
      // else
      //   this.partitions = this.all_partitions.filter(n => {
      //     return n.groups.filter(g => {
      //       return g.processes.find(p => {
      //         return p.name.toUpperCase().includes(filter.toUpperCase());
      //       });
      //     });
      //   });
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete deployed process?"),
        function() {
          local_api(vm, "post", "/ngine_core/process/do-remove", {
            i: vm.lProcess.uuid,
          })
            .then(() => {
              vm.$emit("process_deleted", vm.lProcess.uuid);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
        function() {},
      );
    },
    set_default() {
      let vm = this;
      if (vm.process.is_default) {
        success_toast(vm.$t("process is already default"));
      } else {
        vm.$alertify.confirm(
          vm.$t("are you sure to set this process as default?"),
          function() {
            local_api(vm, "post", "/ngine_core/process/do-set-default", {
              i: vm.lProcess.uuid,
            })
              .then(() => {
                vm.$emit("process_default", vm.lProcess.uuid);
                success_toast(vm.$t("this process is now default"));
              })
              .catch((err) => {
                error_toast(err);
              });
          },
          function() {},
        );
      }
    },
    show_key() {
      this.$alertify.alert(
        this.$t("process public key"),
        this.lProcess.public_key,
      );
    },
  },
  created() {},
  mounted() {
    window.jQuery(".ui.pointing.menu .item").tab();

    getProcess(this, this.process)
      .then(() => {
        // console.log(process);
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {
    process() {
      getProcess(this, this.process)
        .then(() => {
          // console.log(process);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
};

var getProcess = function(vm, process) {
  return new Promise(function(resolve, reject) {
    local_api(vm, "post", "/ngine_core/process/do-get", {
      i: process.uuid,
    })
      .then((_process) => {
        vm.lProcess = _process;
        setTimeout(() => {
          vm.$refs.enrollment.init();
        }, 1000);
        resolve(_process);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
</script>
